import { newRequestMercurio } from "std/api/mercurio/newRequestMercurio";
import type { ApiBaseParams } from "std/api/types";
import type { ApiTransportador } from "../types/ApiTransportador";

export type ApiTransportadorGetParams = ApiBaseParams &
	Partial<{
		pesquisar: string;
		nome: string;
		documento: string;
	}>;

export function apiTransportadorGet({ idpk, params }: { idpk?: number; params?: ApiTransportadorGetParams }): Promise<ApiTransportador[]> {
	return newRequestMercurio({
		url: "Transportador/Transportador",
		type: "get",
		idpk,
		params,
	});
}
